<template>
  <div class="cards-portais">
    <div class="row">
      <div class="col-xs-12">
        <h2>
          Portais de transparência
        </h2>
        <p>
          Aqui você encontra os portais de transparência disponíveis para
          consulta. Você pode acompanhar os concursos públicos vigentes,
          consultar disponibilidade de remédios, entre outras informações,
          selecionando os cards abaixo:
        </p>
      </div>
    </div>
    <div class="row">
      <div
        class="col-xs-12 col-md-4"
        v-for="(portal, index) in portais"
        :key="`portal-${index}`"
      >
        <router-link :to="{ name: portal.nome_rota }" class="card-portal">
          <strong class="text-xl">
            {{ portal.titulo }}
          </strong>
          <p>{{ portal.descricao }}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      portais: [
        {
          titulo: 'Assistência Social',
          descricao: 'Benefícios assistenciais e auxílios',
          nome_rota: 'beneficios_auxilios',
          show: true
        },
        {
          titulo: 'Concursos Publicos',
          descricao: 'Portal dos concursos publicos vigentes',
          nome_rota: 'concursos',
          show: true
        },
        {
          titulo: 'Gastos e Consumo',
          descricao: 'Gastos da Prefeitura com consumo de água/luz',
          nome_rota: 'gastos_consumo',
          show: true
        },
        {
          titulo: 'Conselho Tutelar',
          descricao: 'Resultado das eleições do Conselho Tutelar',
          nome_rota: 'eleicao_conselho',
          show: true
        },
        {
          titulo: 'Dívida Ativa',
          descricao: 'Lista de devedores da dívida ativa do município',
          nome_rota: 'divida-ativa',
          show: true
        },
        {
          titulo: 'Emendas Parlamentares',
          descricao:
            'Listas de emendas parlamentares registradas no ano atual e em anos anteriores',
          nome_rota: 'emendas_parlamentares',
          show: true
        },
        {
          titulo: 'Gestão',
          descricao: 'Materiais padronizados',
          nome_rota: 'materiais',
          show: true
        },
        {
          titulo: 'Plano de Governo',
          descricao: 'Plano municipal de governo',
          nome_rota: 'planodegoverno',
          show: true
        },
        {
          titulo: 'Plano de Metas',
          descricao: 'Plano municipal de metas',
          nome_rota: 'planometas',
          show: true
        },
        {
          titulo: 'Planos Municipais',
          descricao: 'Planos Municipais',
          nome_rota: 'planosmunicipal',
          show: true
        },
        {
          titulo: 'Minha Saúde',
          descricao: 'Fila de espera dos procedimentos da saúde',
          nome_rota: 'procedimentos_saude',
          // nome_rota: 'manutencao',
          show: true
        },
        {
          titulo: 'Movimentos ODS',
          descricao:
            'Aqui você localiza todos os movimentos ODS que as instituições estão organizando.',
          nome_rota: 'movimentos_ods',
          show: true
        },
        {
          titulo: 'Prestação de Contas',
          descricao: 'Prestação de contas das entidades do terceiro setor',
          nome_rota: 'prestacao_contas',
          show: true
        },
        {
          titulo: 'Receitas e Despesas',
          descricao: 'Portal analítico de receitas e despesas',
          nome_rota: 'receitas_despesas',
          show: true
        },
        {
          titulo: 'Remédio Fácil',
          descricao:
            'Aqui você localiza os medicamentos distribuidos pela rede de saúde municipal',
          nome_rota: 'remedio',
          // nome_rota: 'manutencao',
          show: true
        },
        {
          titulo: 'Saúde',
          descricao: 'Escalas de Plantão',
          nome_rota: 'escalas',
          show: true
        }
      ]
    }
  }
}
</script>

<style scoped>
.card-portal {
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-bottom: 15px;
  padding: 10px;
  min-height: 100px;
  max-height: max-content;
  background-color: #266c16;
  color: #fff;
  transition: all 0.2s ease;
}

.card-portal:hover {
  transform: scale(0.95);
}
</style>



// WEBPACK FOOTER //
// src/components/Panel/CardsPortais.vue